import React from 'react';
import { PageContentLayout } from '@/finsight/ui/common/components/ContentLayouts';
import Profile from '@/finsight/ui/components/profile';
import { ProfileTypes } from '@/finsight/application/actions/profile/constants';
import withFinsightGlobalProps from '@/finsight/application/withFinsightGlobalProps';
import getServerSideResearchData from '@/finsight/application/Research/serverSide/getServerSideResearchData';
import { DOCUMENT_GROUP_NAMES } from '@/finsight/domain/DocumentGroup';
import getServerSideTopCompany from '@/finsight/application/TopCompanies/serverSide/getServerSideTopCompany';
import PageFiltersContextProvider from '@/finsight/application/PageFilters/PageFiltersContext';
import getServerSideProfileBreadcrumbs
  from '@/finsight/application/Breadcrumbs/serverSide/getServerSideProfileBreadcrumbs';
import { getServerSideBondsTileData,
} from '@/finsight/application/Bonds/serverSide/getServerSideBondsTileData';
import { getServerSideTraceTileData } from '@/finsight/application/Trace/serverSide/getServerSideTraceTileData';
import IBreadcrumb from '@/finsight/domain/vo/Breadcrumbs';
import getServerSideChartData from '@/finsight/application/MarketChart/serverSide/getServerSideChartData';
import * as FILTER_TYPES from '@/finsight/application/actions/pageFilters/constants';
import ParentPageContextProvider from '@/finsight/application/ParentPageContext';
import getServerSideProfileDeals from '@/finsight/application/Deal/serverSide/getServerSideProfileDeals';
import getServerSideArticlesTile
  from '@/finsight/application/CreditFlowResearch/Articles/ArticlesTile/serverSide/getServerSideArticlesTile';

export const getServerSideProps = withFinsightGlobalProps(async (context) => {
  const deals = await getServerSideProfileDeals(context, { profileType: ProfileTypes.SECTOR });

  const [topParents, researchData, chartData, bondTileData, traceTileData, articlesTilesData] = await Promise.all([
    getServerSideTopCompany(context, { profileType: ProfileTypes.SECTOR }),
    getServerSideResearchData(context, { isTile: true, groupName: DOCUMENT_GROUP_NAMES.REPORTS }),
    getServerSideChartData(context, { filterType: FILTER_TYPES.SECTOR }),
    getServerSideBondsTileData(context),
    getServerSideTraceTileData(context),
    getServerSideArticlesTile(context, { includedDealIds: [] }),
  ]);
  const breadcrumbs: IBreadcrumb[] = getServerSideProfileBreadcrumbs(context, ProfileTypes.SECTOR);

  return ({
    props: {
      breadcrumbs,
      topParents,
      deals,
      researchData,
      chartData,
      bondTileData,
      traceTileData,
      articlesTilesData,
    },
  });
});

const AbsBondIssuanceOverview = (props) => (
  <PageFiltersContextProvider profileType={ ProfileTypes.SECTOR }>
    <ParentPageContextProvider parentProps={ {
        topParents: props?.topParents,
        deals: props?.deals,
        research: props?.researchData,
        chartData: props?.chartData,
        traceTileData: props?.traceTileData,
        bondTileData: props?.bondTileData,
        articlesTilesData: props?.articlesTilesData,
      } }
    >
      <PageContentLayout>
        <Profile profileType={ ProfileTypes.SECTOR } />
      </PageContentLayout>
    </ParentPageContextProvider>
  </PageFiltersContextProvider>
);

export default AbsBondIssuanceOverview;
